// Hand-rolled SVG sparkline — no chart library. Newest ≤100 points.

import type { PricePoint } from '../feed';

export function Sparkline({
  points,
  direction,
  className = 'h-8 w-24',
}: {
  points: PricePoint[];
  direction: 'up' | 'down';
  className?: string;
}) {
  const pts = points.slice(-100);
  if (pts.length === 0) {
    return <svg className={className} aria-hidden="true" />;
  }
  // Single price point (static pre-match quote, nothing has moved yet):
  // duplicate it so the renderer draws a flat line at the current level —
  // points are spaced by index, not time, so this stays visually exact.
  if (pts.length === 1) {
    pts.push(pts[0]);
  }
  const W = 96;
  const H = 32;
  const values = pts.map((p) => p.p);
  const min = Math.min(...values);
  const range = Math.max(...values) - min || 1;
  const coords = pts.map(
    (p, i) =>
      `${((i / (pts.length - 1)) * W).toFixed(1)},${(
        H -
        2 -
        ((p.p - min) / range) * (H - 4)
      ).toFixed(1)}`,
  );
  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      className={className}
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <polyline
        points={coords.join(' ')}
        fill="none"
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
        className={direction === 'up' ? 'stroke-buy' : 'stroke-sell'}
      />
    </svg>
  );
}
